import { useState } from "react";
import { useParams } from "react-router-dom";
import api from "../helpers/axios";
import { LockClosedIcon } from "@heroicons/react/24/outline";

const ActivateAccount = () => {
    const { userId } = useParams();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    const handleActivate = async () => {
        setError(null);
        setMessage(null);
        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        try {
            const res = await api.post(
                `/auth/reset-password/confirm/${userId}`,
                {
                    new_password: password,
                }
            );
            setMessage(res.data.message);
        } catch (err) {
            setError(err.response?.data?.detail || "Activation failed.");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                <h2 className="text-xl font-semibold text-gray-800 mb-6">
                    Activate Your Account
                </h2>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        New Password
                    </label>
                    <div className="relative">
                        <LockClosedIcon className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
                        <input
                            type="password"
                            placeholder="Set your password"
                            className="pl-12 pr-4 py-2 w-full bg-gray-50 border border-gray-300 rounded-full text-gray-700 focus:outline-none focus:ring-2 focus:ring-purple-300"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                </div>

                <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Confirm Password
                    </label>
                    <div className="relative">
                        <LockClosedIcon className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
                        <input
                            type="password"
                            placeholder="Confirm your password"
                            className="pl-12 pr-4 py-2 w-full bg-gray-50 border border-gray-300 rounded-full text-gray-700 focus:outline-none focus:ring-2 focus:ring-purple-300"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </div>
                </div>

                <button
                    onClick={handleActivate}
                    className="w-full py-2 rounded-full bg-gradient-to-r from-purple-400 to-purple-600 text-white font-semibold shadow hover:opacity-95 transition"
                >
                    Activate Account
                </button>

                {message && <p className="text-green-600 mt-4">{message}</p>}
                {error && <p className="text-red-600 mt-4">{error}</p>}
            </div>
        </div>
    );
};

export default ActivateAccount;
